import React, { Fragment, useState, useEffect } from 'react';
import { translate } from '../../Services/translation';
import InventoryEditAddProductPopup from './InventoryEditAddProductPopup';
import InventoryPopup from './InventoryPopup';
import InventoryEditTopCategoryAccodion from './InventoryEditTopCategoryAccordion';
import { get } from '../../Services/http';

const InventoryEditContainer = () => {
  const [isAddProductOpen, setIsAddProductOpen] = useState(false);
  const [topInventoryCategories, setTopInventoryCategories] = useState([]);

  useEffect(() => {
    get('/api/inventoryedit/getinventoryitems')
    .then(response => response.json())
    .then(result => {
      setTopInventoryCategories(result);
    })
  }, []);

  return (
    <Fragment>
      <div className="small-12 text--center">
        <h1>{translate('inventoryedit.heading')}</h1>
      </div>
      <button onClick={() => setIsAddProductOpen(true)}>{translate('brenderup.inventoryedit.addproduct')}</button>
      <InventoryPopup 
        isOpen={isAddProductOpen} 
        setOpen={setIsAddProductOpen}
        onClose={setIsAddProductOpen}
        component={
          <InventoryEditAddProductPopup setOpen={setIsAddProductOpen} setProducts={setTopInventoryCategories}/>
        }
      />

      {!topInventoryCategories.length ? (
        <Fragment>
          <p>{translate('product.noproducts')}</p>
        </Fragment>
        ) : (
          <Fragment>
            {topInventoryCategories &&
              topInventoryCategories.map((topInventoryCategory, index) => {
                return (
                  <InventoryEditTopCategoryAccodion topInventoryCategory={topInventoryCategory} isOpen={index === 0} setProducts={setTopInventoryCategories}/>
                )
              })}
          </Fragment>
        )
      }
      <h4 className='info-text'>{translate('inventoryedit.info')}</h4>
    </Fragment>
  );
};

export default InventoryEditContainer;